// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = function noop(): void {};
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const anoop = async function anoop(): Promise<void> {};